// Shared SVG paths for button-like components (PillButton, NavButton, TextInput)
// These define the 3D gradient effect with shadow, border, and main gradient layers

// Shadow/base layer path - rounded rectangle with small corner radius
export const BUTTON_SHADOW_PATH =
  'M20 2H382C392.49 2 401 10.51 401 21V85C401 95.49 392.49 104 382 104H20C9.51 104 1 95.49 1 85V21C1 10.51 9.51 2 20 2Z';

// Black border path (outer and inner combined)
export const BUTTON_BORDER_PATH =
  'M382 4C391.39 4 399 11.61 399 21V85C399 94.39 391.39 102 382 102H20C10.61 102 3 94.39 3 85V21C3 11.61 10.61 4 20 4H382M382 0H20C8.4 0 -1 9.4 -1 21V85C-1 96.6 8.4 106 20 106H382C393.6 106 403 96.6 403 85V21C403 9.4 393.6 0 382 0Z';

// Main button gradient path
export const BUTTON_MAIN_PATH =
  'M382 4H20C10.61 4 3 11.61 3 21V72C3 81.39 10.61 89 20 89H382C391.39 89 399 81.39 399 72V21C399 11.61 391.39 4 382 4Z';
